<template>
  <v-layout row>
    <div v-if="isLoading">
      <v-progress-circular
        :indeterminate="isLoading"
        color="primary"
      ></v-progress-circular>
    </div>
    <div v-if="subscriptionLoad">
      <v-progress-circular
        :indeterminate="subscriptionLoad"
        color="primary"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="headline">Atualizar Pagamento Recorrente: {{subscription.id}}</span>
          </v-card-title>
          <v-card-title v-if="newPaymentError">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              outline
            >
              <p>Erro ao atualizar pagamento!</p>
              <p>Código: {{response.errors[0].response_code}}</p>
              <p>Detalhe: {{response.errors[0].response_code_detail}}</p>
            </v-alert>
          </v-card-title>
          <v-card-title v-if="newPaymentStatus">
            <v-alert
              :value="true"
              color="success"
              icon="check_circle"
              outline
            >
              Pagamento recorrente atualizado com sucesso, com ID: {{response[0].id}}
            </v-alert>
          </v-card-title>
          <v-progress-linear :indeterminate="isLoading"></v-progress-linear>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-xl fluid>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field  label="Valor" v-model.lazy="subscription.amount" v-money="money" :rules="amountRules"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    value=""
                    label="À cada"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field id="rangeSize" type='number' v-model.lazy="subscription.range_size" :rules="amountRules" label="Intervalo"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    v-model.lazy="subscription.range_type_select"
                    :items="rangeTypes"
                    item-text="name"
                    item-value="value"
                    label="Tipo de intervalo"
                    persistent-hint
                    v-on:change="changeRangeType"
                    return-object
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <p>Próximo pagamento: {{setDateFormat(subscription.next)}}</p>
                  <v-text-field v-model="next" id="next" type="tel" v-mask="'##/##/####'" label="Alterar próximo" />
                </v-flex>
                <v-flex xs6>
                  <p>Válidade atual: {{setDateFormat(subscription.final_date)}}</p>
                  <v-text-field v-model="finalDate" id="finalDate" type="tel" v-mask="'##/##/####'" label="Alterar Validade" />
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="validate">Enviar</v-btn>
              </v-card-actions>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { changed } from '@/helpers/layout';
  import {VMoney} from 'v-money';
  import {mask} from 'vue-the-mask';
  import moment from 'moment';
  import format from 'date-fns/format';

  export default {
    name: 'SubscriptionUpdate',
    components: {mask},
    data: () => ({
      alert: false,
      valid: true,
      subsMonths: [],
      picker: new Date().toISOString().substr(0, 10),
      rangeType: "monthly",
      rangeSize: '1',
      finalDate: '',
      dueOn: '',
      next: '',
      amountRules: [
        v => !!v || 'Valor deve ser válido',
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      days: Array.from({length: 31}, (v, k) => k+1),
      rangeTypes: [
        { name: 'Dia', value: 'daily'},
        { name: 'Mês', value: 'monthly'},
        { name: 'Ano', value: 'yearly'},
      ],
      months: [
        { name: 'Jan', value: '01'},
        { name: 'Fev', value: '02'},
        { name: 'Mar', value: '03'},
        { name: 'Abr', value: '04'},
        { name: 'Mai', value: '05'},
        { name: 'Jun', value: '06'},
        { name: 'Jul', value: '07'},
        { name: 'Ago', value: '08'},
        { name: 'Set', value: '09'},
        { name: 'Out', value: '10'},
        { name: 'Nov', value: '11'},
        { name: 'Dez', value: '12'},
      ],
      years: [
        { name: `${(new Date().getFullYear()).toString()}`, value: `${(new Date().getFullYear()).toString()}`},
        { name: `${(new Date().getFullYear()+1).toString()}`, value: `${(new Date().getFullYear()+1).toString()}`},
        { name: `${(new Date().getFullYear()+2).toString()}`, value: `${(new Date().getFullYear()+2).toString()}`},
        { name: `${(new Date().getFullYear()+3).toString()}`, value: `${(new Date().getFullYear()+3).toString()}`},
        { name: `${(new Date().getFullYear()+4).toString()}`, value: `${(new Date().getFullYear()+4).toString()}`},
        { name: `${(new Date().getFullYear()+5).toString()}`, value: `${(new Date().getFullYear()+5).toString()}`},
        { name: `${(new Date().getFullYear()+6).toString()}`, value: `${(new Date().getFullYear()+6).toString()}`},
        { name: `${(new Date().getFullYear()+7).toString()}`, value: `${(new Date().getFullYear()+7).toString()}`},
        { name: `${(new Date().getFullYear()+8).toString()}`, value: `${(new Date().getFullYear()+8).toString()}`},
        { name: `${(new Date().getFullYear()+9).toString()}`, value: `${(new Date().getFullYear()+9).toString()}`},
        { name: `${(new Date().getFullYear()+10).toString()}`, value: `${(new Date().getFullYear()+10).toString()}`},
        { name: `${(new Date().getFullYear()+11).toString()}`, value: `${(new Date().getFullYear()+11).toString()}`},
        { name: `${(new Date().getFullYear()+12).toString()}`, value: `${(new Date().getFullYear()+12).toString()}`},
        { name: `${(new Date().getFullYear()+13).toString()}`, value: `${(new Date().getFullYear()+13).toString()}`},
        { name: `${(new Date().getFullYear()+14).toString()}`, value: `${(new Date().getFullYear()+14).toString()}`},
        { name: `${(new Date().getFullYear()+15).toString()}`, value: `${(new Date().getFullYear()+15).toString()}`},
      ],
    }),
    directives: {money: VMoney, mask},
    created() {
      this.$store.dispatch('invoices/subscription', parseInt(this.$route.params.id));
    },
    mounted() {
      this.$store.commit('payments/LOADING_DATA', false);
      this.$store.commit('invoices/LOADING_DATA', false);
    },
    computed: {
      ...mapGetters({
        subscription: 'invoices/subscription',
        subscriptionLoad: 'invoices/loadingData',
        response: 'payments/newPayment',
        isLoading: 'payments/loadingData',
        newPaymentError: 'payments/newPaymentError',
        newPaymentStatus: 'payments/newPaymentStatus',
      }),
    },
    methods: {
      changeRangeType () {
        this.rangeType = this.subscription.range_type_select.value
      },
      validate () {
        this.$store.commit('payments/LOADING_DATA', true);
        this.$store.commit('invoices/LOADING_DATA', true);
        if (this.$refs.form.validate()) {
          this.subscription_update = {
            id: this.subscription.id,
            amount: this.subscription.amount.replace(/\D/g, ''),
            range_type: this.rangeType,
            range_size: this.subscription.range_size
          }
          this.empty(this.finalDate) ? null : this.subscription_update.final_date = this.finalDate,
          this.empty(this.next) ? null : this.subscription_update.next = this.next

          this.$store.dispatch('payments/updateSubscription', this.subscription_update)
          this.alert = this.isLoading
          this.$refs.form.reset()
          this.$store.commit('payments/LOADING_DATA', false);
          this.$store.commit('invoices/LOADING_DATA', false);
          this.$router.go('/subscription');
        }
      },
      empty(str) {
        if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str)) {
          return true;
        } else {
          return false;
        }
      },
      updatePage () {
        window.location.reload()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      setDateFormat(date) {
      if (date === null) {
        return ''
      } else {
        return new Date(date).toLocaleDateString("pt-BR")
      }
    }
    },
  }
</script>

<style>

@font-face {
  font-family: 'fontello';
  src: url('../../../../assets/fonts/fontello.eot');
  src: url('../../../../assets/fonts/fontello.eot?13442593#iefix') format('embedded-opentype'),
        url('../../../../assets/fonts/fontello.woff2?13442593') format('woff2'),
        url('../../../../assets/fonts/fontello.woff?13442593') format('woff'),
        url('../../../../assets/fonts/fontello.ttf?13442593') format('truetype'),
        url('../../../../assets/fonts/fontello.svg?13442593#fontello') format('svg');
  font-weight: normal;
  font-style: normal;
}
</style>
